var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiddleSizeArrow = function SvgMiddleSizeArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m17.414 11.086-4.293-4.293-1.414 1.414L15 11.5H5v2h10l-3.293 3.293 1.414 1.414 4.293-4.293a2 2 0 0 0 0-2.828"
  })));
};
export { SvgMiddleSizeArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjQxNCAxMS4wODZMMTMuMTIxIDYuNzkyOTdMMTEuNzA3IDguMjA2OTdMMTUgMTEuNUg1VjEzLjVIMTVMMTEuNzA3IDE2Ljc5M0wxMy4xMjEgMTguMjA3TDE3LjQxNCAxMy45MTRDMTcuNzg4OSAxMy41Mzg5IDE3Ljk5OTYgMTMuMDMwMyAxNy45OTk2IDEyLjVDMTcuOTk5NiAxMS45Njk2IDE3Ljc4ODkgMTEuNDYxIDE3LjQxNCAxMS4wODZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";